/**
 * Show a snackbar as a notification indicating an error.
 * @param {Function} commit to commit a mutation
 * @param {String} message the message to show
 */
export function notifyError(commit, message) {
  commit('notifications/notify', { type: 'error', message }, { root: true })
}


/**
 * Show a snackbar as a notification indicating any successful message.
 * @param {Function} commit to commit a mutation
 * @param {String} message the message to show
 */
export function notifySuccess(commit, message) {
  commit('notifications/notify', { type: 'success', message }, { root: true })
}

export default {
  notifyError,
  notifySuccess
}
